export default __webpack_public_path__ + "static/media/Ing-product.1a20fdb5.png";